import { createSelector } from '@ngrx/store';
import { IProfessionalServiceState } from './professional-service.reducer';
const professionalServiceStore = (state: any) =>
  state.professionalService as IProfessionalServiceState;
export const selectProfessionalServicoLista = createSelector(
  professionalServiceStore,
  (state) => state.lista
);

export const selectProfessionalServico = createSelector(
  professionalServiceStore,
  (state) => state
);

export const selectProfessionalServicoType = createSelector(
  professionalServiceStore,
  (state) => state.type
);

export const selectProfessionalServiceState = createSelector(
  professionalServiceStore,
  (state) => ({type: state.type, action: state.action})
)